import React from 'react';

type Props = {
  width: number;
  height: number;
  fill?: string;
}

const ConverseDataSourceIcon = ({
  width, height, fill,
}: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill={fill}
  >
    <path
      d="M9.88897 16.1847H3.74194V10.0458C3.74272 9.2325 3.90282 8.42798 4.21242 7.68153C4.52202 6.93508 4.9746 6.26243 5.54241 5.70484C6.7133 4.5413 8.27147 3.89673 9.88897 3.9068C11.5067 3.89662 13.0651 4.54119 14.2362 5.70484C14.8047 6.26191 15.2577 6.93445 15.5674 7.68102C15.877 8.42758 16.0368 9.23236 16.0368 10.0458C16.0368 10.8592 15.877 11.6639 15.5674 12.4105C15.2577 13.1571 14.8047 13.8296 14.2362 14.3867C13.0651 15.5503 11.5067 16.1949 9.88897 16.1847ZM6.20095 10.9849V12.2128H11.7331V10.9849H6.20095ZM6.20095 8.32481V9.55239H13.578V8.32652L6.20095 8.32481Z"
      fill={fill}
    />
  </svg>
);

ConverseDataSourceIcon.defaultProps = {
  fill: 'var(--leadsquaredIconBlue)',
};

export default ConverseDataSourceIcon;
